module.exports = __webpack_public_path__ + "img/7.12bb29a9.gif";